import { ComponentType, lazy } from 'react'

const RELOAD_KEY = 'app:chunk-reload-at'
const RELOAD_COOLDOWN = 60_000

// Old tabs can request chunks removed by a deployment. Refresh at most once a
// minute; don't reset the guard when another chunk loads successfully.
export async function importWithReload<T>(load: () => Promise<T>): Promise<T> {
  try {
    return await load()
  } catch (error) {
    const chunkError = error as { name?: string; code?: string } | null
    if (chunkError?.name === 'ChunkLoadError' || chunkError?.code === 'CSS_CHUNK_LOAD_FAILED') {
      try {
        const lastReload = Number(sessionStorage.getItem(RELOAD_KEY))
        if (!lastReload || Date.now() - lastReload >= RELOAD_COOLDOWN) {
          // Persist before reloading so concurrent failures and the next page
          // load cannot cause a refresh loop.
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
          window.location.reload()
          return new Promise<T>(() => {})
        }
      } catch {
        // If storage is unavailable, don't risk a reload loop.
      }
    }
    throw error
  }
}

export default function lazyWithReload<T extends ComponentType<any>>(
  load: () => Promise<{ default: T }>,
) {
  return lazy(() => importWithReload(load))
}
